<template>
  <div>
    <a
      v-if="type === 'text'"
      style="font-weight: 500; text-decoration: none"
      @click="dialogIsOpen = true"
    >
      {{ $t('features.tickets.create_ticket') }}
      <font-awesome-icon class="fa-fw fa-rotate-45-left" icon="ticket-alt" />
    </a>
    <Button v-else :size="size" @click="dialogIsOpen = true">
      <font-awesome-icon class="fa-fw fa-rotate-45-left" icon="ticket-alt" />
      {{ $t('features.tickets.create_ticket') }}
    </Button>
    <create-ticket-dialog
      v-model:visible="dialogIsOpen"
      :title="suggestedTitle"
      :description="suggestedDescription"
      :plant="asPlant(plantJson)"
      :company-id="companyId"
      @ticket-created="$emit('ticket-created', $event)"
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PlantJson } from '@/data/plants/PlantJson.ts';
import Address from '@/domain/model/business/Address.ts';
import Plant from '@/domain/model/business/Plant.ts';
import {
  issueShortDescription,
  issueLongDescription,
} from '@/presentation/components/status/IssueDescriptions.ts';
import MeterIssueApi from '@/data/meters/MeterIssueApi.ts';
import CreateTicketDialog from './CreateTicketDialog.vue';

export default {
  name: 'CreateTicketFromPlantJsonButton',
  components: { CreateTicketDialog },
  props: {
    type: { type: String, default: 'button' },
    size: { default: 'small' },
    plantJson: {
      type: Object as PropType<PlantJson>,
      required: true,
    },
    companyId: Number,
  },
  emits: ['ticket-created'],
  data() {
    return {
      dialogIsOpen: false,
    };
  },
  created() {
    new MeterIssueApi().getAllTypes();
  },
  computed: {
    suggestedTitle() {
      const issueNames = this.plantJson.meter_issues;
      if (issueNames.length === 0) {
        return this.plantJson.name;
      } else if (issueNames.length === 1) {
        return issueShortDescription(this.plantJson.meter_issues[0].type_name);
      } else {
        return 'Multiple issues';
      }
    },
    suggestedDescription() {
      const issueNames = this.plantJson.meter_issues;
      return issueNames.length === 1
        ? issueLongDescription(this.plantJson.meter_issues[0].type_name)
        : null;
    },
  },
  methods: {
    asPlant(plantJson: any) {
      const address = new Address(plantJson.address);

      return new Plant(
        plantJson,
        plantJson.id,
        plantJson.name,
        plantJson.plant_code,
        plantJson.time_zone,
        plantJson.monitored_since,
        plantJson.owning_company_id,
        plantJson.weather_station_id,
        plantJson.yield_score_7d,
        plantJson.yield_score_30d,
        address,
      );
    },
  },
};
</script>
